var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('i',{staticClass:"far fa-copyright"}),_vm._v(" "+_vm._s(new Date().getFullYear())+" Henrik Davidsen. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }